import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { makeObservable, observable, runInAction } from "mobx";
class TcfFeature {
    data;
    special;
    store;
    constructor(data, special, store){
        makeObservable(this);
        runInAction(()=>{
            this.special = special;
            this.data = data;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], TcfFeature.prototype, "data", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Boolean)
], TcfFeature.prototype, "special", void 0);
export { TcfFeature };
